import { Link } from 'react-router-dom';
import React from 'react';

const MainMenu = () => {
    return (
        <>
            <ul>
                <li ><Link to='/'>Home</Link>
                    {/* <ul className='sub-menu'>
                        <li><Link to='/'>Home 01</Link></li>
                        <li><Link to='/home-two'>Home 02</Link></li>
                        <li><Link to='/home-three'>Home 03</Link></li>
                        <li><Link to='/home-four'>Home 04</Link></li>
                    </ul> */}
                </li>  
                <li className='menu-item-has-children'><Link to='#'>Services</Link>
                    <ul className='sub-menu'>
                        <li><Link to='/services/architecture'>Architectural</Link></li>
                        <li><Link to='/services/engineering'>Engineering</Link></li>
                        <li><Link to='/services/construction'>Construction</Link></li>
                        <li><Link to='/services/consultancy'>Consultancy</Link></li>
                        {/* <li className='menu-item-has-children'><Link to='/services'>Services</Link>
                            <ul className='sub-menu'>
                                <li><Link to='/services'>Services</Link></li>
                                <li><Link to='/services/building-architecture'>Services Details</Link></li>
                            </ul>
                        </li>
                        <li><Link to='/testimonial'>Testimonials</Link></li>
                        <li><Link to='/pricing-plans'>Price Plans</Link></li>
                        <li><Link to='/faq'>FAQ's</Link></li>
                        <li className='menu-item-has-children'><Link to='/team'>Teams</Link>
                            <ul className='sub-menu'>
                                <li><Link to='/team'>Team 01</Link></li>
                                <li><Link to='/team-two'>Team 02</Link></li>
                                <li><Link to='/team-three'>Team 03</Link></li>
                            </ul>
                        </li>
                        <li><Link to='/request-quote'>Request Quote</Link></li>
                        <li><Link to='/404-error'>404 Page</Link></li> */}
                    </ul>
                </li>
                <li ><Link to='/gallery'>Gallery</Link>
                    
                </li>
                <li ><Link to='/services/import-supply'>Import & Supply</Link></li>
                {/* <li ><Link to='#'>Real State</Link></li> */}
                <li ><Link to='/about-us'>About us</Link>
                    {/* <ul className='sub-menu'>
                        <li><Link to='/blog'>Our Mission</Link></li>
                        <li><Link to='/blog-standard'>Our Vision</Link></li>
                    </ul> */}
                </li>
                <li><Link to='/contact-us'>Contact Us</Link></li>      
            </ul>  
        </>
    );
};

export default MainMenu;